export default [
    //海博景观
    {
        path: '/scenery',
        name: 'scenery',
        component: () => import('../views/news/scenery.vue'),
        meta: {
            hasTabbar: true,
            title: '海博景观'
        }
    },
    //海博头条
    {
        path: '/headlines',
        name: 'headlines',
        component: () => import('../views/news/headlines.vue'),
        meta: {
            hasTabbar: true,
            title: '海博头条'
        }
    },
    //海博头条详情
    {
        path: '/headlinesDetailed',
        name: 'headlinesDetailed',
        component: () => import('../views/news/headlinesDetailed.vue'),
        meta: {
            hasTabbar: false,
            title: '海博头条详情'
        }
    },
];
